import { PlatformLocation } from '@angular/common';
import { getAuthConfig } from '@common/app/app.config';
import { getIdentityUri, findDomainKey } from '@lang/jp/auth-helper';
import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

const defaultCommunities = {
    'default': 'kanagawa',
    'tmg': 'tokyo',
    'niigata': 'niigata',
};

export function getDefaultCommunity(platformLocation: PlatformLocation) {
    const domainKey = findDomainKey(platformLocation)
    return defaultCommunities[domainKey];

}

export function getBaseHref(platformLocation: PlatformLocation): string {
    return platformLocation.getBaseHrefFromDOM();
}

export function getCmsApiUrl(platformLocation: PlatformLocation): string {
    const useTestCms = platformLocation.href.includes('?testCms=true');
    if (useTestCms && environment.testCmsUri) {
        return environment.testCmsUri;
    }
    return environment.cmsUri;
}

export function authConfigFactory(
    platformLocation: PlatformLocation,
): AuthConfig {
    const identityUri = getIdentityUri(environment, platformLocation);

    return getAuthConfig(identityUri);
}
